export { getEcomRequiredApps, getBackendEventSlug } from './client.js';
export { useExtensionDataClient } from './useExtensionDataClient.js';
export { ExtensionDataClient } from './extension-data-client.js';
export {
  sdkSlotSchema,
  backOfficePageSchema,
  backOfficeExtensionContainerSchema,
} from './schema.js';
export type {
  ImportData,
  SdkSlotData,
  BackOfficeExtensionContainer,
  BackOfficePage,
  WidgetPlugin,
  Placement,
} from './schema.js';
export type { AppDependencies, RequiredApp } from './types.js';
